import { TextValidator } from "react-material-ui-form-validator"

const TextAnswerQuestion = ({
  question,
  questionIdx,
  isCompleted,
  onChange,
  onBlur,
}) => {
  return (
    <div className="full-width" key={questionIdx}>
      <div className="form__fieldset">
        <label htmlFor={`field_${questionIdx}`} className="form__label">
          Question {questionIdx + 1}
        </label>
        <div className="form__fieldbox">
          <div className="form__masked-value">
            <pre>{question.title}</pre>
          </div>
        </div>
      </div>

      <div className="form__fieldset">
        <label htmlFor={`field_${questionIdx}`} className="form__label">
          Answer
        </label>
        <div className="form__fieldbox">
          <div className="form__input">
            <TextValidator
              name={`field_${questionIdx}`}
              id={`field_${questionIdx}`}
              placeholder={"Type your answer"}
              multiline
              fullWidth
              margin="normal"
              onChange={(e) => onChange(e, questionIdx)}
              onBlur={onBlur}
              value={question.user_answer_text}
              disabled={isCompleted}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TextAnswerQuestion
